module.exports = __webpack_public_path__ + "client/img/world_01.2da183d8.png";